
//const serverUrl = "http://localhost:64360/";
//const serverUrl= "http://192.168.1.6:64360/";
const serverUrl = "https://AceAcademyApi.seedoc.ir/";
const apiUrl = `${serverUrl}api`;

export {serverUrl, apiUrl}
